/**
 * Coarse-grained roles, stored in the Firebase Auth custom claim `role`.
 * Kept small and stable — fine-grained access lives in the `permissions`
 * collection (see `PERMISSIONS`), not as more roles.
 */
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  VENDOR: 'vendor',
  CUSTOMER: 'customer',
  DELIVERY_PARTNER: 'delivery_partner',
  SUPPORT_AGENT: 'support_agent',
} as const;

export type RoleValue = (typeof ROLES)[keyof typeof ROLES];

/** Roles considered "back office" — i.e. never assigned by public self-registration. */
export const STAFF_ROLES: readonly RoleValue[] = [
  ROLES.SUPER_ADMIN,
  ROLES.ADMIN,
  ROLES.VENDOR,
  ROLES.DELIVERY_PARTNER,
  ROLES.SUPPORT_AGENT,
];

export const ADMIN_PORTAL_ROLES: readonly RoleValue[] = [
  ROLES.SUPER_ADMIN,
  ROLES.ADMIN,
  ROLES.SUPPORT_AGENT,
];
